import React from 'react'

export const QuoteIcon = ({
  width = '44',
  height = '32',
  fill = 'none',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4021 0.533981C13.5804 -0.349672 15.2518 -0.110898 16.1355 1.06729C17.0192 2.2455 16.7803 3.91697 15.6022 4.80065C11.4316 7.92862 9.03964 10.9698 7.67444 13.6264C8.41852 13.4354 9.19846 13.3338 10.0021 13.3338C15.1568 13.3338 19.3355 17.5125 19.3355 22.6672C19.3355 27.8218 15.1568 32.0005 10.0021 32.0005C4.89905 32.0005 0.752518 27.905 0.670038 22.8216C0.429505 20.5149 0.464625 17.1122 2.02356 13.1837C3.61673 9.16897 6.72857 4.78921 12.4021 0.533981ZM36.4021 0.533981C37.5803 -0.349672 39.2517 -0.110898 40.1355 1.06729C41.0192 2.2455 40.7803 3.91697 39.6021 4.80065C35.4315 7.92862 33.0397 10.9698 31.6744 13.6264C32.4184 13.4354 33.1984 13.3338 34.0021 13.3338C39.1568 13.3338 43.3354 17.5125 43.3354 22.6672C43.3354 27.8218 39.1568 32.0005 34.0021 32.0005C28.8989 32.0005 24.7525 27.905 24.6701 22.8216C24.4296 20.5149 24.4645 17.1122 26.0235 13.1837C27.6168 9.16897 30.7285 4.78921 36.4021 0.533981Z"
        fill="white"
      />
    </svg>
  )
}
